import { getAuthAxiosBackend } from "../helpers/axios"

class DeathCertificateServices{

    get(id){
        return getAuthAxiosBackend().get('deathCertificates/getDeathCertificates/' + id.toString())
    }

    getByPersonId(personId){
        return getAuthAxiosBackend().get('DeathCertificates/getDeathCertificatesByPersonId/' + personId)
    }

    getAll(data = {}){
        return getAuthAxiosBackend().get('deathCertificates/all', {params: data})
    }

    add(data){
        return getAuthAxiosBackend().post('DeathCertificates/addDeathCertificates', data)
    }

    edit(id, data){
        return getAuthAxiosBackend().put('DeathCertificates/updateDeathCertificates/' + id, data)
    }

    delete(id){
        return getAuthAxiosBackend().delete('deathCertificates/softDeleteDeathCertificates/' + id.toString())
    }
}

export default new DeathCertificateServices()